<template>
    <section class="flex-column content-full">
        <a class="block block-bordered">
            <div class="block-header block-header-default">
                <h3 class="block-title">
                    SMS Short Codes and Alphanumerics
                </h3>
            </div>
            <div class="block-content-full border-top">
                <table class="table table-striped table-condensed">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Services</th>
                        <th>Created At</th>
                        <th>..</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(shortCode, idx) of shortCodes">
                        <td>{{++idx}}</td>
                        <th>{{shortCode.senderName}}</th>
                        <th>{{shortCode.productType}}</th>
                        <th>{{shortCode.status}}</th>
                        <th>{{shortCode.services.data.length}}</th>
                        <th>{{shortCode.created_at}}</th>
                        <th>
                            <div class="dropdown">
                                <button type="button" class="btn-block-option" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                    <i class="si si-menu"/>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                                    <a class="dropdown-item" href="#">
                                        <i class="fa fa-fw fa-share-alt mr-1"/> Link To Project
                                    </a>
                                </div>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
        </a>
    </section>

</template>

<script>
    import {APP_CONFIG} from "../../config";

    export default {
        name: "UserShortCodes",
        data() {
            return {
                shortCodes: []
            }
        },
        mounted() {
            this.getUserShortCodes()
        },
        methods: {
            getUserShortCodes() {
                axios.get(APP_CONFIG.URL + 'services/sms/short-codes').then(res => {
                    this.shortCodes = res.data.data
                })
            }
        }
    }
</script>

<style scoped>

</style>
